import React, { useEffect, useState } from 'react'
import { HabilitationAccordion } from '../access/HabilitationAccordion'
import { HYDRO } from '../../../constants/ApplicationHabilitationConstants'
import i18n from '../../../../../../simple-react-i18n'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import HydrometryAction from '../../../../../../hydrometry/actions/HydrometryAction'
import DtoHydrometricStation from '../../../../../../hydrometry/dto/DtoHydrometricStation'

const HabilitationHydro = ({}) => {
    const dispatch = useDispatch()
    const {
        hydrometricStations,
    } = useSelector(store => ({
        hydrometricStations: store.HydrometryReducer.hydrometricStations,
    }), shallowEqual)

    const [isLoaded, setIsLoaded] = useState(false)

    useEffect(() => {
        if (hydrometricStations.length === 0) {
            dispatch(HydrometryAction.fetchHydrometricStations())
                .then(() => setIsLoaded(true))
        } else {
            setIsLoaded(true)
        }
    }, [dispatch])

    return (
        <HabilitationAccordion
            stationType={HYDRO}
            title={i18n.hydrometry}
            stations={hydrometricStations}
            isLoaded={isLoaded}
        />
    )
}

HabilitationHydro.propTypes = {
    hydrometricStations: PropTypes.arrayOf(PropTypes.instanceOf(DtoHydrometricStation)),
    fetchHydrometricStations: PropTypes.func,
}

export default HabilitationHydro